import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import TwrDevicesHealth from '@app/components/TwrDevicesHealth/TwrDevicesHealth'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage,
} from '@app/hocs'
import { AppDispatch } from '@app/store'
import { AppState } from '@app/@types/store'
import { DeviceTypes } from '@app/@types/myDevices'

let enhance = TwrDevicesHealth

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { devices } = state.myDevices.myDevices
  const twrDevices = devices.filter((device) => device.device_type === DeviceTypes.twrDevice)
  return {
    isMobile,
    devices,
    twrDevices,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const TwrDevicesHealthEnhanced = enhance

export default TwrDevicesHealthEnhanced
